export default "__VITE_ASSET__DMjBuId5__"